import { render, staticRenderFns } from "./add-edit-reminder.vue?vue&type=template&id=2202c6a1&scoped=true&lang=html"
import script from "./add-edit-reminder.vue?vue&type=script&lang=js"
export * from "./add-edit-reminder.vue?vue&type=script&lang=js"
import style0 from "./add-edit-reminder.vue?vue&type=style&index=0&id=2202c6a1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2202c6a1",
  null
  
)

export default component.exports